import React, {useState} from "react";
import InputMask from 'react-input-mask';
import tw from "twin.macro";
import styled from "styled-components";
import {SectionHeading} from "../../../components/misc/Headings.js";
import {PrimaryButton as PrimaryButtonBase} from "../../../components/misc/Buttons.js";
import { FaInstagram, FaTelegramPlane, FaWhatsapp, FaTiktok } from "react-icons/fa";
import { useTranslation } from "react-i18next";


const Container = tw.div`relative bg-white`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-8 md:py-12 items-center`;

const Heading = tw(SectionHeading)`mt-2 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const SocialIcons = styled.div`
    ${tw`mt-4 flex gap-6 items-center`}
    font-size: 28px;
    a {
        transition: transform 0.2s;
        &:hover {
            transform: scale(1.1);
        }
    }
`;

const TextColumn = tw(Column)`md:w-5/12 md:order-first flex flex-col gap-4 mb-auto`;
const FormColumn = tw(Column)`md:w-7/12 lg:w-8/12 flex items-center justify-center mb-auto`;

const TextContent = tw.div`lg:py-8 text-center md:text-left`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-2xl text-secondary-600 md:leading-snug`;

const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col w-full max-w-4xl mx-auto md:mx-0 gap-6`;

const Input = styled.input`
    ${tw` px-6 py-4 text-lg font-medium w-full transition duration-300`};
    color: #203859;
    border: none;
    border-bottom: 2px solid #adb5bd;
    font-family: inherit;
    width: 400px; // или больше

    &::placeholder {
        color: #203859;
    }
    &:hover {
        border-bottom-color: #0ABD19;
    }
    &:focus {
        outline: none;
        border-bottom-color: #0ABD19;
    }
    &:-webkit-autofill {
        transition: background-color 9999s ease-in-out 0s;
        -webkit-text-fill-color: #203859 !important;
        box-shadow: 0 0 0px 1000px white inset;
    }
`;

const PhoneInput = styled(InputMask)`
    ${tw`px-6 py-4 text-lg font-medium w-full transition duration-300`};
    color: #6c757d;
    border: none;
    border-bottom: 2px solid #adb5bd;
    font-family: inherit;
    width: 400px; // или больше
    &::placeholder {
        color: #203859;
    }
    &:hover {
        border-bottom-color: #0ABD19;
    }
    &:focus {
        outline: none;
        border-bottom-color: #0ABD19;
    }
`;

const SelectWrapper = styled.div`
    ${tw`relative`};
`;

const SelectButton = styled.button`
    ${tw`appearance-none w-full px-6 py-4 text-lg border-b-2 border-gray-300 bg-white text-left`};
    border-top: 0;
    border-left: 0;
    border-right: 0;
    color: ${({selected}) => (selected ? '#203859' : '#203859')};
    font-family: inherit;
    &:hover {
        border-bottom-color: #0ABD19;
    }
    &:focus {
        outline: none;
        border-bottom-color: #0ABD19;
    }
`;

const Dropdown = styled.div`
    ${tw`absolute mt-1 w-full rounded-md bg-white z-10`};
    box-shadow: none;
    border-bottom: 2px solid #adb5bd;
`;

const Option = styled.div`
    ${tw`cursor-pointer px-4 py-3 text-gray-700 hover:bg-gray-200 text-sm`};
`;

const Textarea = styled.textarea`
    ${tw`px-6 py-4 text-lg font-medium w-full transition duration-300 border-b-2 h-32 resize`};
    color: #203859;
    border: none;
    border-bottom: 2px solid #adb5bd;
    font-family: inherit;
    &::placeholder {
        color: #203859;
    }
    &:hover {
        border-bottom-color: #0ABD19;
    }
    &:focus {
        outline: none;
        border-bottom-color: #0ABD19;
    }
    &:-webkit-autofill {
        transition: background-color 9999s ease-in-out 0s;
        -webkit-text-fill-color: #203859 !important;
        box-shadow: 0 0 0px 1000px white inset;
    }
`;

const SubmitButton = styled(PrimaryButtonBase)`
    ${tw`inline-block mt-12`}
    background-color: #0ABD19;
    border-radius: 10px;
    &:hover {
        background-color: #098E14;
    }
`;

const Highlight = styled.span`
    color: #0ABD19;
`;




const ContactForm = ({
                         heading = (
                             <>
                                 <Highlight> Связаться</Highlight> с нами!
                             </>
                         ),
                         submitButtonText = "Отправить",
                         formAction = "#",
                         formMethod = "get",
                         textOnLeft = true,
                     }) => {
    const { t } = useTranslation();
    const optionsSubject = [
        { value: "", label: t("contactForm.subjectPlaceholder"), disabled: true },
        { value: "insurance", label: t("contactForm.subject.insurance") },
        { value: "delivery", label: t("contactForm.subject.delivery") },
        { value: "packaging", label: t("contactForm.subject.packaging") },
        { value: "customs", label: t("contactForm.subject.customs") },
        { value: "complaint", label: t("contactForm.subject.complaint") },
        { value: "warehouse", label: t("contactForm.subject.warehouse") },
        { value: "refund", label: t("contactForm.subject.refund") },
        { value: "return", label: t("contactForm.subject.return") },
        { value: "storage", label: t("contactForm.subject.storage") },
        { value: "other", label: t("contactForm.subject.other") },
        { value: "business", label: t("contactForm.subject.business") },
    ];

    const optionsContact = [
        { value: "", label: t("contactForm.contactPlaceholder"), disabled: true },
        { value: "phone", label: t("contactForm.contact.phone") },
        { value: "email", label: t("contactForm.contact.email") },
    ];

    const [selectedSubject, setSelectedSubject] = useState("");
    const [subjectDropdownOpen, setSubjectDropdownOpen] = useState(false);

    const [selectedContactMethod, setSelectedContactMethod] = useState("");
    const [contactDropdownOpen, setContactDropdownOpen] = useState(false);

    const handleSelectSubject = (value) => {
        setSelectedSubject(value);
        setSubjectDropdownOpen(false);
    };

    const handleSelectContactMethod = (value) => {
        setSelectedContactMethod(value);
        setContactDropdownOpen(false);
    };

    const toggleDropdown = (event, setDropdownOpen) => {
        event.preventDefault();
        setDropdownOpen((prev) => !prev);
    };

    return (
        <>

        <Container>
            <TwoColumn>
                <TextColumn>
                    <TextContent>
                        <Heading>{t("contactForm.contactTitle")}</Heading>

                        <Description>
                            <p>{t("contacts.phoneTitle")}</p>
                            <p>{t("contacts.phone")}</p>
                            <br />
                            <p>{t("contacts.warehouseTitle")}</p>
                            <p>{t("contacts.warehouseWeekdays")}</p>
                            <p>{t("contacts.warehouseWeekend")}</p>
                            <br />
                            <p>{t("contacts.email")}</p>
                        </Description>
                        <SocialIcons>
                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" title="Instagram">
                                <FaInstagram color="#E4405F" />
                            </a>
                            <a href="https://t.me" target="_blank" rel="noopener noreferrer" title="Telegram">
                                <FaTelegramPlane color="#0088cc" />
                            </a>
                            <a href="https://wa.me" target="_blank" rel="noopener noreferrer" title="WhatsApp">
                                <FaWhatsapp color="#25D366" />
                            </a>
                            <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" title="TikTok">
                                <FaTiktok color="#000000" />
                            </a>
                        </SocialIcons>

                    </TextContent>
                </TextColumn>

                <FormColumn>
                    <TextContent>
                        <Heading>{t("contactForm.contactTitle")}</Heading>
                        <Form action={formAction} method={formMethod}>
                            <Input type="text" name="name" placeholder={t("contactForm.name")} />
                            <PhoneInput mask="+7 (999) 999-99-99" placeholder={t("contactForm.phone")} />
                            <Input type="email" name="email" placeholder="Email" />                            <SelectWrapper>
                                <SelectButton
                                    selected={selectedSubject}
                                    onClick={(event) => toggleDropdown(event, setSubjectDropdownOpen)}
                                >
                                    {optionsSubject.find(option => option.value === selectedSubject)?.label || "Выберите тему обращения"}
                                </SelectButton>
                                {subjectDropdownOpen && (
                                    <Dropdown>
                                        {optionsSubject.filter(option => !option.disabled).map((option) => (
                                            <Option
                                                key={option.value}
                                                onClick={() => handleSelectSubject(option.value)}
                                                style={{
                                                    color: option.disabled ? "#ccc" : "#000",
                                                    pointerEvents: option.disabled ? "none" : "auto"
                                                }}
                                            >
                                                {option.label}
                                            </Option>
                                        ))}
                                    </Dropdown>
                                )}
                            </SelectWrapper>
                            <SelectWrapper>
                                <SelectButton
                                    selected={selectedContactMethod}
                                    onClick={(event) => toggleDropdown(event, setContactDropdownOpen)}
                                >
                                    {optionsContact.find(option => option.value === selectedContactMethod)?.label || "Выберите удобный способ связи"}
                                </SelectButton>
                                {contactDropdownOpen && (
                                    <Dropdown>
                                        {optionsContact.filter(option => !option.disabled).map((option) => (
                                            <Option
                                                key={option.value}
                                                onClick={() => handleSelectContactMethod(option.value)}
                                                style={{
                                                    color: option.disabled ? "#ccc" : "#000",
                                                    pointerEvents: option.disabled ? "none" : "auto"
                                                }}
                                            >
                                                {option.label}
                                            </Option>
                                        ))}
                                    </Dropdown>
                                )}
                            </SelectWrapper>
                            <Textarea name="message" placeholder={t("contactForm.message")} />
                            <SubmitButton type="submit">{t("contactForm.submit")}</SubmitButton>
                        </Form>
                    </TextContent>
                </FormColumn>

            </TwoColumn>
        </Container>
</>

);
};

export default ContactForm;
